import { render, staticRenderFns } from "./MembershipGuarantees.vue?vue&type=template&id=00d65aa4"
import script from "./MembershipGuarantees.vue?vue&type=script&lang=js"
export * from "./MembershipGuarantees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports